import React from 'react'
import styled, { css } from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

interface CheckboxProps {
  name?: string
  isChecked?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  idPrefix?: string
}

export const Checkbox: React.FC<CheckboxProps> = ({
  isChecked,
  onChange,
  className,
  name,
  children,
  idPrefix,
  ...rest
}) => {
  return (
    <Wrapper
      htmlFor={`${idPrefix || ''}${name}`}
      className={className}
      checked={isChecked}
    >
      <input
        type='checkbox'
        id={`${idPrefix || ''}${name}`}
        name={name}
        checked={isChecked}
        onChange={onChange}
        {...rest}
      />
      {children}
    </Wrapper>
  )
}

interface WrapperProps {
  checked?: boolean
}

const Wrapper = styled.label<WrapperProps>`
  position: relative;
  overflow: hidden;
  display: inline-block;
  padding-left: 30px;
  cursor: pointer;
  color: ${themeEstra.color.primari.grigioEstra};

  input {
    position: absolute;
    opacity: 0;
    left: -100px;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }

  &:before {
    background-color: ${({ theme }) => theme.color.neutri.grigioBg};
    border: 1px solid ${({ theme }) => theme.color.neutri.grigioChiaro};
  }

  &:after {
    ${({ checked }) =>
      checked
        ? css`
            background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
            background-size: 10px;
            background-position: center;
            background-repeat: no-repeat;
            background-color: ${({ theme }) => theme.color.primari.verde};
          `
        : null};
  }
`
